import React, { useState } from 'react';
import { ChevronDown, ArrowRight } from 'lucide-react';
import { Button } from './ui/Button';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onClick: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onClick
}: FAQItemProps) {
  return <div className="border border-amber-200 rounded-xl overflow-hidden bg-white" data-id="element-15">
      <button onClick={onClick} className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-amber-50 transition-colors" data-id="element-16">
        <span className="font-bold text-slate-900 text-lg pr-4" data-id="element-17">
          {question}
        </span>
        <ChevronDown className={`h-5 w-5 text-blue-900 flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-18" />
      </button>
      <div className={`overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-96' : 'max-h-0'}`} data-id="element-19">
        <div className="px-6 pb-5 text-slate-600 leading-relaxed" data-id="element-20">{answer}</div>
      </div>
    </div>;
}
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: '¿En qué formato recibo el material?',
    answer: '100% digital (PDF descargables) listos para usar desde cualquier dispositivo. Acceso inmediato a todo el contenido.'
  }, {
    question: '¿Puedo imprimir las clases y actividades?',
    answer: 'Sí, están diseñados específicamente para imprimir o proyectar en clase. Sin restricciones de uso.'
  }, {
    question: '¿Para qué años de secundaria sirve?',
    answer: 'El material está adaptado para todos los años de secundaria donde se enseña Derecho. Incluye contenidos desde nivel básico hasta avanzado, cubriendo todo el ciclo lectivo.'
  }, {
    question: '¿Las actividades son difíciles de implementar?',
    answer: 'No. Todas las actividades están pensadas para realizarse en el aula con recursos accesibles. No necesitás materiales especiales ni preparación compleja.'
  }, {
    question: '¿Cuánto tarda en llegar el acceso?',
    answer: 'El acceso es inmediato. Recibes un correo electrónico con tus datos de acceso segundos después de la compra. Podés empezar a usar el material de inmediato.'
  }, {
    question: '¿Hay actualizaciones incluidas?',
    answer: 'Sí, todas las actualizaciones futuras están incluidas sin costo adicional. A medida que actualicemos el contenido, tendrás acceso automático.'
  }];
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="py-20 bg-amber-50" data-id="element-21">
      <div className="container mx-auto px-4" data-id="element-22">
        <div className="max-w-3xl mx-auto" data-id="element-23">
          <div className="text-center mb-12" data-id="element-24">
            <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-25">
              Preguntas Frecuentes
            </h2>
            <p className="text-slate-600" data-id="element-26">
              Todo lo que necesitás saber sobre DERECHO 360
            </p>
          </div>

          <div className="space-y-4 mb-12" data-id="element-27">
            {faqs.map((faq, index) => <FAQItem key={index} question={faq.question} answer={faq.answer} isOpen={openIndex === index} onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-28" />)}
          </div>

          {/* CTA Block */}
          <div className="bg-slate-100 rounded-2xl p-8 md:p-12 text-center" data-id="element-29">
            <h3 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-30">
              ¿Listo para transformar tu año escolar?
            </h3>
            <p className="text-lg text-slate-600 mb-8 max-w-2xl mx-auto" data-id="element-31">
              Únete a cientos de docentes que ya organizaron su año de Derecho
              sin estrés
            </p>
            <Button onClick={scrollToPricing} size="xl" className="shadow-xl" data-id="element-32">
              <span className="flex items-center gap-2" data-id="element-33">
                QUIERO EMPEZAR AHORA
                <ArrowRight className="h-5 w-5" data-id="element-34" />
              </span>
            </Button>
            <p className="text-sm text-slate-500 mt-4" data-id="element-35">
              Descarga inmediata • Garantía de 7 días
            </p>
          </div>
        </div>
      </div>
    </section>;
}